exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reset-title[data-v-5982251f] {\n  font-weight: 500;\n  font-size: 40px;\n  line-height: 48px;\n  letter-spacing: -0.72px;\n  color: #131c36;\n}\n.reset-undertitle[data-v-5982251f] {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: #3e475e;\n  max-width: 347px;\n  margin-top: 7px;\n  margin-bottom: 39px;\n}\n.back-link[data-v-5982251f] {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.0875px;\n  color: #2962ff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5982251f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/ForgotPasswordEmailSent.vue
// module id = BuUx
// module chunks = 0